var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.filtroAVigilar.length !== 0)?_c('v-btn',{class:_vm.botonEnVivoClass,attrs:{"color":"red","rounded":"","elevation":"8"},on:{"click":_vm.verEnVivo}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-record-circle")]),_vm._v(" En vivo ")],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }